<template>
  <div class="pull-new" v-show="show" @click.self="changeShow">
    <div id="creatImgBefore" v-show="!dataUrl">
      <img
        class="bg"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/pull-new.jpeg"
        alt=""
        crossorigin="anonymous"
        @load="imageLoaded"
      />
      <div id="qrcode"></div>
      <p>长按/截图保存图片并分享给好友</p>
    </div>
    <div id="creatImgBefore" v-show="dataUrl && !isApp" class="success">
      <img class="userImg" :src="dataUrl" alt />
      <p class="tips">长按/截图保存图片并分享给好友</p>
    </div>
  </div>
</template>
<script>
import loadJS from 'load-js';
import html2canvas from 'html2canvas';
import { copyTool } from '@/utils/tools';
import { mapState } from 'vuex';
export default {
  props: {
    activityId: {
      type: Number,
      default: 0,
    },
    currentTask: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      isApp: this.$root.isApp,
      miniprogram: this.$root.miniprogram,
      dataUrl: null,
      show: false,
      canvasImgShow: false,
    };
  },
  methods: {
    changeShow() {
      console.log(1111111)
      this.show = !this.show;
      if (this.isApp && this.dataUrl) {
        this.showAppShare();
        return;
      }
      if (this.dataUrl || !this.show) return;
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      setTimeout(() => {
        this.creatQrCode();
      }, 100);
    },
    imageLoaded(){
      console.log(2222222)
    },
    creatQrCode() {
      const url = `${window.location.origin}/ark/collectCardIndex?cardActivityId=${this.activityId}&cardTaskId=${this.currentTask.id}&userId=${this.userInfo.id}`;
      console.log('创建二维码', url);
      const clientWidth = document.getElementById('qrcode').offsetWidth;
      // eslint-disable-next-line no-new, no-undef
      new QRCode(document.getElementById('qrcode'), {
        text: url,
        render: 'table',
        width: clientWidth,
        height: clientWidth,
        typeNumber: -1, // 计算模式
        correctLevel: 0, // 纠错等级   correctLevel
      });
      console.log('创建二维码成功了', document.getElementById('qrcode'));
      setTimeout(() => {
        this.createCanvas();
      }, 2000);
    },
    createCanvas() {
      html2canvas(document.getElementById('creatImgBefore'), {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        console.log(dataURL);
        this.dataUrl = dataURL;
        this.$toast.clear();
        this.showAppShare();
      });
    },
    // 调用app原生方法
    showAppShare() {
      if (this.isApp) {
        const url = `${window.location.origin}/ark/collectCardIndex?cardActivityId=${this.activityId}&cardTaskId=${this.currentTask?.id}&userId=${this.userInfo.id}`;
        this.$sendToApp(
          'shareStudyReport',
          {
            url: this.dataUrl,
            copyLink: url,
          },
          false,
        );
        this.show = false;
      }
    },
    close() {
      this.show = false;
    },
  },
  watch: {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    setTimeout(() => {
      window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
    }, 100);
  },
};
</script>
<style scoped lang="scss">
.pull-new {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.8);
  .account__share {
    position: absolute;
    width: 600px;

    .userImg {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }

    .tips {
      height: 40px;
      margin-top: 58px;
      color: #fff;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;
    }
  }
}
#creatImgBefore.success {
  p {
    padding-top: 18px;
  }
}
#creatImgBefore {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 621px;
  height: 791px;
  // background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/pull-new.png')
  //   no-repeat;
  // background-size: 100%;
  transform: translate(-50%, -50%);
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 621px;
    width: 100%;
    height: 791px;
    height: 100%;
    border-radius: 40px;
  }
  #qrcode {
    position: absolute;
    right: 68px;
    bottom: 40px;
    width: 140px;
    height: 140px;
    canvas,
    img {
      width: 100% !important;
      height: 100% !important;
    }
  }
  p {
    padding-top: 814px;
    color: #fff;
    font-weight: 500;
    font-size: 30px;
    text-align: center;
  }
  img.userImg {
    width: 621px;
    height: 791px;
  }
}
</style>
